import React from 'react';
import { Tooltip } from 'antd';
import { Wrapper } from './styled';

interface IParams {
  text: string | React.ReactNode;
  left: number | string;
}

const CustomChartTooltip = ({ text, left }: IParams) => {
  if (!text) {
    return null;
  }
  return (
    <Tooltip
      title={text}
      open
      placement="right"
      getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
    >
      <Wrapper left={left} />
    </Tooltip>
  );
};

export default CustomChartTooltip;
